export const httpPromise = function (component, url, method, data, successCallback, errorCallback) {

    var baseUrl = 'https://silverkitchen.ir/api';
    var baseUrl_2 = 'https://silverkitchen.ir/api';
    var accessToken = localStorage.getItem('accessToken');
    var authorizationHeader = accessToken && accessToken !== 'null' && accessToken !== 'undefined'
        ? { 'Authorization': 'Bearer ' + accessToken }
        : {};
    switch (method.toLocaleLowerCase().trim()) {
     //********************************************************************************************************************************
        case 'get_2':
            component.$http.get(baseUrl_2 + url, { params: data, headers: authorizationHeader }).then(
                response => {
                    if (successCallback != null)
                        successCallback(response);
                },
                response => {
                    if (response.status == 401) {
                        localStorage.removeItem('accessToken');
                        component.$router.push('/login');
                    }
                    if (response.status == 400) {
                        if (errorCallback != null)
                            errorCallback(response);
                    } else {

                    }
                });
            break;
        //********************************************************************************************************************************
        case 'get':
            component.$http.get(baseUrl + url, { params: data, headers: authorizationHeader }).then(
                response => {
                    if (successCallback != null)
                        successCallback(response);
                },
                response => {
                    if (response.status == 401) {
                        localStorage.removeItem('accessToken');
                        component.$router.push('/login');
                    }
                    if (response.status == 400) {
                        if (errorCallback != null)
                            errorCallback(response);
                    } else {

                    }
                });
            break;
        //********************************************************************************************************************************
        case 'post':
            component.$http.post(baseUrl + url, data, { headers: Object.assign({ 'Content-Type': 'application/json' }, authorizationHeader) }).then(
                response => {
                    if (successCallback != null)
                        successCallback(response);
                },
                response => {
                    if (response.status == 401) {
                        localStorage.removeItem('accessToken');
                        component.$router.push('/login');
                    }
                    if (response.status == 400) {
                        if (errorCallback != null)
                            errorCallback(response);
                    } else {

                    }
                });
            break;
        //********************************************************************************************************************************
        case 'delete':
            component.$http.delete(baseUrl + url, { params: data, headers: authorizationHeader }).then(
                response => {
                    if (successCallback != null)
                        successCallback(response);
                },
                response => {
                    if (response.status == 401) {
                        localStorage.removeItem('accessToken');
                        component.$router.push('/login');
                    }
                    if (response.status == 400) {
                        if (errorCallback != null)
                            errorCallback(response);
                    } else {

                    }
                });
            break;
        case 'put':
            component.$http.put(baseUrl + url, data, { headers: Object.assign({ 'Content-Type': 'application/json' }, authorizationHeader) }).then(
                response => {
                    if (successCallback != null)
                        successCallback(response);
                },
                response => {
                    if (response.status == 401) {
                        localStorage.removeItem('accessToken');
                        component.$router.push('/login');
                    }
                    if (response.status == 400) {
                        if (errorCallback != null)
                            errorCallback(response);
                    } else {

                    }
                });
            break;
    }

}

export const htmlLoader = function (component, url, successCallback, errorCallback) {
    component.$http.get(url).then(
        response => {
            if (successCallback != null)
                successCallback(response);
        },
        response => {
            if (errorCallback != null)
                errorCallback(response);
        });
}
